function u(e) {
  const n = e.regex, a = {
    $pattern: /[\w.\/]+/,
    built_in: [
      "action",
      "bindattr",
      "collection",
      "component",
      "concat",
      "debugger",
      "each",
      "each-in",
      "get",
      "hash",
      "if",
      "in",
      "input",
      "link-to",
      "loc",
      "log",
      "lookup",
      "mut",
      "outlet",
      "partial",
      "query-params",
      "render",
      "template",
      "textarea",
      "unbound",
      "unless",
      "view",
      "with",
      "yield"
    ]
  }, T = {
    $pattern: /[\w.\/]+/,
    literal: [
      "true",
      "false",
      "undefined",
      "null"
    ]
  }, l = /""|"[^"]+"/, A = /''|'[^']+'/, i = /\[\]|\[[^\]]+\]/, _ = /[^\s!"#%&'()*+,.\/;<=>@\[\\\]^`{|}~]+/, R = /(\.|\/)/, c = n.either(
    l,
    A,
    i,
    _
  ), d = n.concat(
    n.optional(/\.|\.\/|\//),
    // relative or absolute path
    c,
    n.anyNumberOfTimes(n.concat(
      R,
      c
    ))
  ), m = n.concat(
    "(",
    i,
    "|",
    _,
    ")(?==)"
  ), t = { begin: d }, o = e.inherit(t, { keywords: T }), s = {
    begin: /\(/,
    end: /\)/
    // the "contains" is added below when all necessary sub-modes are defined
  }, I = {
    // fka "attribute-assignment", parameters of the form 'key=value'
    className: "attr",
    begin: m,
    relevance: 0,
    starts: {
      begin: /=/,
      end: /=/,
      starts: { contains: [
        e.NUMBER_MODE,
        e.QUOTE_STRING_MODE,
        e.APOS_STRING_MODE,
        o,
        s
      ] }
    }
  }, g = {
    // parameters of the form '{{#with x as | y |}}...{{/with}}'
    begin: /as\s+\|/,
    keywords: { keyword: "as" },
    end: /\|/,
    contains: [
      {
        // define sub-mode in order to prevent highlighting of block-parameter named "as"
        begin: /\w+/
      }
    ]
  }, E = {
    contains: [
      e.NUMBER_MODE,
      e.QUOTE_STRING_MODE,
      e.APOS_STRING_MODE,
      g,
      I,
      o,
      s
    ],
    returnEnd: !0
    // the property "end" is defined through inheritance when the mode is used. If depends
    // on the surrounding mode, but "endsWithParent" does not work here (i.e. it includes the
    // end-token of the surrounding mode)
  }, O = e.inherit(t, {
    className: "name",
    keywords: a,
    starts: e.inherit(E, { end: /\)/ })
  });
  s.contains = [O];
  const r = e.inherit(t, {
    keywords: a,
    className: "name",
    starts: e.inherit(E, { end: /\}\}/ })
  }), N = e.inherit(t, {
    keywords: a,
    className: "name"
  }), S = e.inherit(t, {
    className: "name",
    keywords: a,
    starts: e.inherit(E, { end: /\}\}/ })
  });
  return {
    name: "Handlebars",
    aliases: [
      "hbs",
      "html.hbs",
      "html.handlebars",
      "htmlbars"
    ],
    case_insensitive: !0,
    subLanguage: "xml",
    contains: [
      {
        begin: /\\\{\{/,
        skip: !0
      },
      {
        begin: /\\\\(?=\{\{)/,
        skip: !0
      },
      e.COMMENT(/\{\{!--/, /--\}\}/),
      e.COMMENT(/\{\{!/, /\}\}/),
      {
        // open raw block "{{{{raw}}}} content not evaluated {{{{/raw}}}}"
        className: "template-tag",
        begin: /\{\{\{\{(?!\/)/,
        end: /\}\}\}\}/,
        contains: [r],
        starts: {
          end: /\{\{\{\{\//,
          returnEnd: !0,
          subLanguage: "xml"
        }
      },
      {
        // close raw block
        className: "template-tag",
        begin: /\{\{\{\{\//,
        end: /\}\}\}\}/,
        contains: [N]
      },
      {
        // open block statement
        className: "template-tag",
        begin: /\{\{#/,
        end: /\}\}/,
        contains: [r]
      },
      {
        className: "template-tag",
        begin: /\{\{(?=else\}\})/,
        end: /\}\}/,
        keywords: "else"
      },
      {
        className: "template-tag",
        begin: /\{\{(?=else if)/,
        end: /\}\}/,
        keywords: "else if"
      },
      {
        // closing block statement
        className: "template-tag",
        begin: /\{\{\//,
        end: /\}\}/,
        contains: [N]
      },
      {
        // template variable or helper-call that is NOT html-escaped
        className: "template-variable",
        begin: /\{\{\{/,
        end: /\}\}\}/,
        contains: [S]
      },
      {
        // template variable or helper-call that is html-escaped
        className: "template-variable",
        begin: /\{\{/,
        end: /\}\}/,
        contains: [S]
      }
    ]
  };
}
export {
  u as default
};
